module.exports = __webpack_public_path__ + "i18n/ja.0d2af5d9b7b027899b6449fce00f2afb.json";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=i18n/[name].[hash].[ext]!./i18n/ja.json
// module id = 1287
// module chunks = 60